import React, { useMemo } from 'react';
import cx from 'classnames';
import { Link } from 'react-router-dom';
import { pluralize } from 'js/utils/string';
import {
  countQuestionSetsAndQuestions,
  countWeightSchemes,
} from 'js/utils/rubric';

import FavoriteStamp from 'js/components/FavoriteStamp';

import styles from './TeamRubrics.module.scss';

function RubricListItem({
  workspaceId,
  teamId,
  rubric,
  isFavoriteUpdating = () => false,
  onToggleFavorite = () => {},
}) {
  const { questionSetCount, questionCount, weightSchemeCount } = useMemo(() => {
    const doc = rubric?.document;
    return {
      ...countQuestionSetsAndQuestions(doc),
      weightSchemeCount: countWeightSchemes(doc),
    };
  }, [rubric?.document]);

  return (
    <li
      className={cx(styles['rubric-item'], {
        favorite: !!rubric.favorite,
      })}
    >
      <span>
        <FavoriteStamp
          favorited={!!rubric.favorite}
          payload={rubric}
          onClick={onToggleFavorite}
          disabled={!!isFavoriteUpdating?.(rubric.id)}
        />
      </span>
      <span>
        <Link
          to={`/w/${workspaceId}/teams/${teamId}/rubrics/${encodeURIComponent(
            rubric.id
          )}`}
        >
          {rubric.name}
        </Link>
      </span>
      <ul className={styles['rubric-details']}>
        <li className={styles['rubric-detail']}>
          {questionSetCount}
          {pluralize(questionSetCount, ' question set', ' question sets')}
        </li>
        <li className={styles['rubric-detail']}>
          {questionCount}
          {pluralize(questionCount, ' question', ' questions')}
        </li>
        <li className={styles['rubric-detail']}>
          {weightSchemeCount}
          {pluralize(weightSchemeCount, ' weight scheme', ' weight schemes')}
        </li>
      </ul>
    </li>
  );

  // return (
  //   <div className={styles['rubric-list-item']}>
  //     <div>
  //       <Link to={`/w/${workspaceId}/teams/${teamId}/rubrics/${rubric.id}`}>
  //         {rubric.name}
  //       </Link>
  //     </div>
  //   </div>
  // );
}

export default RubricListItem;
